export const menuItems: { to: string; title: string; onlyFooter: boolean }[] = [
  { to: "/", title: "Home", onlyFooter: false },
  { to: "/#features", title: "Features", onlyFooter: false },
  { to: "/#about-us", title: "About us", onlyFooter: false },
  { to: "mailto:info@getdogsapp.com", title: "Contact us", onlyFooter: false },
  { to: "/privacy-policy", title: "Privacy policy", onlyFooter: true },
  { to: "/terms-of-service", title: "Terms of service", onlyFooter: true },
];
